import type { CoverageDimensionScore } from '@shared/domain/coverageDimensions';
import { COVERAGE_DIMENSION_CODES } from '@shared/domain/coverageDimensions';
import { MiniCompletenessDonut } from './MiniCompletenessDonut';

interface MiniCoverageDimensionSummaryProps {
  dimensions: CoverageDimensionScore[];
  meanScore: number;
}

export function MiniCoverageDimensionSummary({
  dimensions,
  meanScore,
}: MiniCoverageDimensionSummaryProps) {
  const scoreByCode = new Map(dimensions.map(dimension => [dimension.code, dimension.score]));

  return (
    <div className="demo-graph-card-summary flex flex-col gap-1.5">
      <div className="flex items-center justify-between gap-2">
        <span className="text-[6px] text-text-secondary">{meanScore}% mean coverage</span>
        <MiniCompletenessDonut value={meanScore} />
      </div>
      <div className="demo-graph-card-dimension-grid grid grid-cols-3 gap-x-1 gap-y-0.5">
        {COVERAGE_DIMENSION_CODES.map(code => (
          <span key={code} className="text-[6px] font-mono text-text-quaternary">
            {code} {scoreByCode.get(code) ?? 0}
          </span>
        ))}
      </div>
    </div>
  );
}
